import { SearchStringProvider } from '@barboxx/admin-utils';
import { Business } from '@barboxx/models';

import { UserTable } from './UserTable';

interface Props {
    business?: Business;
}

export function Employees({ business }: Props) {
    return (
        <SearchStringProvider>
            <UserTable business={business} />
        </SearchStringProvider>
    );
}
